import React from 'react';

import { RefreshControl, StyleSheet, ScrollView } from 'react-native';
// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
// eslint-disable-next-line no-unused-vars
import Theme from 'Theme';
import { ActivityIndicator, Background, Footer, AssetList } from 'LocalGluons';
import NavigationService from 'NavigationService';
import { itemHasStarted } from 'Utils';
import { withStore } from 'Store';
import defaultStyles from './RecordingsDetails.jss';

// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
// eslint-disable-next-line no-unused-vars
const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    text: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.primaryFontSize,
        marginHorizontal: 20,
        color: Theme.primaryTextColor,
        justifyContent: 'center',
        alignItems: 'center'
    }
});

class Page extends React.Component {
    constructor(props) {
        super(props);
        this.pageOptions = null;
        this.firstLoad = true;
        this.state = {
            loaded: false,
            refreshing: false,
            // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
            // eslint-disable-next-line react/no-unused-state
            promoCarousels: [],
            assetLists: []
        };

        this.pageData = null;

        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line react/prop-types
        const { navigation } = props;

        this.contextId = `${navigation.state.routeName}/${navigation.state.key}`;
    }

    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/sort-comp
    onRefresh = () => {
        this.initializePage();
    };

    componentDidMount = () => {
        this.initializePage();
    };

    parseItems = (items, isNowOnTv = false) => {
        let parsedItems = [...items];
        if (isNowOnTv) {
            parsedItems = parsedItems.filter((item) => itemHasStarted(item));
        }

        return parsedItems;
    };

    loadPlaylist = async (item) => {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line react/prop-types
        const { appManager } = this.props;

        try {
            const { items } = await appManager.getPlaylistItems(item.playlistId);
            this.setState({ assetLists: items });
        } catch (error) {
            console.log(error);
        }
    };

    initializePage = async () => {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line react/prop-types
        const { navigation, route } = this.props;
        NavigationService.setAppNavigationInstance(navigation);
        this.pageOptions = route.params?.pageOptions || undefined;

        if (!this.firstLoad) {
            this.setState({ refreshing: true });
        }

        try {
            await Promise.all([this.loadPlaylist(this.pageOptions)]);

            this.setState({
                loaded: true,
                refreshing: false
            });
        } catch (error) {
            this.setState({
                loaded: true,
                refreshing: false
            });
        }

        this.firstLoad = false;
    };

    render() {
        const { loaded, refreshing, assetLists } = this.state;
        const { handleScroll } = this.props;

        return (
            <Background>
                <ScrollView
                    contentContainerStyle={[defaultStyles.container, { paddingTop: 60 }]}
                    onScroll={handleScroll}
                    scrollEventThrottle={NavigationService.DEFAULT_SCROLL_THROTTLE}
                    refreshControl={
                        <RefreshControl
                            colors={[Theme.primaryActiveColor]}
                            tintColor={Theme.primaryActiveColor}
                            refreshing={refreshing}
                            onRefresh={this.onRefresh}
                        />
                    }
                >
                    <AssetList style={{}} items={assetLists} />
                    <Footer />
                </ScrollView>
                {!loaded ? (
                    <ActivityIndicator key="pageActivityIndicator" testID="pageActivityIndicator" />
                ) : null}
            </Background>
        );
    }
}

export default withStore(Page);
